
import Vue from "vue"
import { getAttributes } from "~/utils/block"

interface Page {
  id?: string
  blocks?: Array<Record<string, any>>
  categories: {
    nodes: Array<{
      slug: string
    }>
  }
}

interface ComponentData {
  blocks: Array<Record<string, any>>
}

export default Vue.extend({
  name: "PageLayoutRemovalsHub",

  props: {
    page: {
      type: Object as () => Page,
      required: true
    }
  },

  data(): ComponentData {
    return {
      blocks: []
    }
  },

  created() {
    this.blocks = [...(this.page?.blocks ?? [])]
  },

  methods: {
    getAttributes,

    isGeocityCategory(): boolean {
      const category = this.page.categories.nodes.find(
        (category): boolean => category.slug === "geocity"
      )
      return !!category
    }
  }
})
